/* eslint-disable camelcase */
export default {
  show_as_grid: "Показать списком",
};
